import Vue from 'vue'

const state = {
  productions: {}
}

const mutations = {
  SET_PRODUCTIONS (state, productions) {
    state.productions = productions
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return
    /* return Vue.prototype.$axios.get('productions/')
      .then(response => {
        commit('SET_PRODUCTIONS', response.data)
      }) */
  }
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
